import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getApiUrl } from '../utils/apiConfig';

const Header = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const [showProfile, setShowProfile] = useState(false);
  const [name, setName] = useState(user.name);
  const [pwd, setPwd] = useState('');
  const [pwd2, setPwd2] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  const saveProfile = async () => {
    try {
      setSaving(true);
      setError('');
      if (name && name !== user.name) {
        const url = await getApiUrl('/api/auth/profile/name');
        const resp = await axios.put(url, { name });
        const updated = resp.data.user || { ...user, name };
        localStorage.setItem('user', JSON.stringify(updated));
      }
      if (pwd) {
        if (pwd.length < 6 || pwd !== pwd2) {
          setError('Password must be 6+ chars and match confirmation');
        } else {
          const url2 = await getApiUrl('/api/auth/profile/password');
          await axios.put(url2, { currentPassword: undefined, newPassword: pwd });
        }
      }
      setShowProfile(false);
      setPwd('');
      setPwd2('');
    } catch (e) {
      setError(e.response?.data?.message || 'Failed to save profile');
    } finally {
      setSaving(false);
    }
  };

  return (
    <header className="header">
      <div className="header-content">
                  <div className="header-title" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <img src="/moshi_media - orange 200x60.svg" alt="Moshi Media" className="header-logo" />
            <span>Subtitle Editor</span>
          </div>
        <div className="header-user">
          <div className="user-info" onClick={() => setShowProfile(true)} style={{ cursor: 'pointer' }}>
            <div className="user-name">{user.name}</div>
            <div className="user-role">{user.user_type}</div>
          </div>
          <div className="header-actions">
            <button 
              className="btn btn-secondary" 
              onClick={handleLogout}
              style={{ fontSize: '0.875rem', padding: '6px 12px' }}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
      {showProfile && (
        <div className="modal-overlay" style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div className="modal" style={{ background: '#fff', padding: '1rem', borderRadius: '8px', width: 'min(420px, 90vw)' }}>
            <h3 style={{ marginTop: 0 }}>Edit Profile</h3>
            {error && <div className="alert alert-danger" style={{ marginBottom: '1rem' }}>{error}</div>}
            <div className="form-group">
              <label>Name</label>
              <input value={name} onChange={(e) => setName(e.target.value)} />
            </div>
            <div className="form-group">
              <label>New Password (optional)</label>
              <input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} />
            </div>
            <div className="form-group">
              <label>Confirm New Password</label>
              <input type="password" value={pwd2} onChange={(e) => setPwd2(e.target.value)} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
              <button className="btn btn-secondary" onClick={() => setShowProfile(false)} disabled={saving}>Cancel</button>
              <button className="btn btn-primary" onClick={saveProfile} disabled={saving}>{saving ? 'Saving…' : 'Save'}</button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header; 